import { useState } from 'react';

export default function Home() {
  const [showOrderModal, setShowOrderModal] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      {/* ヘッダー */}
      <header className="fixed top-0 left-0 right-0 z-50 transition-all duration-300 bg-white/95 backdrop-blur-sm shadow-sm">
        <div className="container mx-auto px-6 py-4 flex items-center justify-between">
          <img 
            src="https://static.readdy.ai/image/01cf1105d91d36948be7a446b8f667b1/8f1db646094399b0c1803ff796086d6b.png" 
            alt="うるマルシェ" 
            className="h-12 w-auto"
          />
          <a 
            href="https://urumarche.myshopify.com/collections/%E9%99%90%E5%AE%9A%E8%B2%A9%E5%A3%B2-%E6%B4%A5%E5%A0%85%E3%81%AB%E3%82%93%E3%81%98%E3%82%93%E3%83%AD%E3%83%BC%E3%83%AB-%E5%BA%97%E9%A0%AD%E5%8F%97%E5%8F%96%E3%81%AE%E3%81%BF"
            target="_blank"
            rel="noopener noreferrer"
            className="px-6 py-2.5 bg-orange-500 text-white text-sm font-medium rounded-full hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            ご予約はこちら
          </a>
        </div>
      </header>

      {/* ファーストビュー */}
      <section className="relative pt-32 pb-20 px-6">
        <div className="container mx-auto max-w-6xl">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <p className="text-orange-500 text-sm font-medium mb-4">2026年3月7日 イベント限定</p>
              <h1 className="text-4xl md:text-5xl font-bold text-gray-900 leading-tight mb-6">
                【限定販売】<br />津堅にんじん、<br />特別な2つのかたち。
              </h1>
              <p className="text-lg text-gray-600 mb-8 leading-relaxed">
                イベント当日だけの、予約でしか手に入らない津堅にんじん商品。
              </p>
              <a 
                href="https://urumarche.myshopify.com/collections/%E9%99%90%E5%AE%9A%E8%B2%A9%E5%A3%B2-%E6%B4%A5%E5%A0%85%E3%81%AB%E3%82%93%E3%81%98%E3%82%93%E3%83%AD%E3%83%BC%E3%83%AB-%E5%BA%97%E9%A0%AD%E5%8F%97%E5%8F%96%E3%81%AE%E3%81%BF"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-8 py-3.5 bg-orange-500 text-white text-base font-medium rounded-full hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                予約販売を見る
              </a>
            </div>
            <div className="relative">
              <div className="w-full rounded-2xl overflow-hidden shadow-xl">
                <img 
                  src="https://static.readdy.ai/image/01cf1105d91d36948be7a446b8f667b1/dc17aa47516c573b71be242b8e335606.jpeg" 
                  alt="津堅にんじん商品" 
                  className="w-full h-auto object-cover"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 商品紹介セクション */}
      <section className="py-20 px-6">
        <div className="container mx-auto max-w-6xl">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-16">
            津堅にんじんの限定商品
          </h2>

          {/* 商品① ロールケーキ */}
          <div className="mb-24">
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div className="order-2 md:order-1">
                <div className="inline-block px-4 py-1.5 bg-orange-100 text-orange-600 text-xs font-medium rounded-full mb-4">
                  イベント限定・予約販売
                </div>
                <p className="text-sm text-gray-500 font-medium mb-2">Restaurant B・B・R</p>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  津堅にんじんロールケーキ
                </h3>
                <p className="text-2xl font-bold text-orange-500 mb-6">
                  1本 2,100円<span className="text-base font-normal text-gray-600">（税込）</span>
                </p>
                <p className="text-base text-gray-600 leading-relaxed mb-6">
                  沖縄県うるま市の隠れ家フレンチ「レストランB・B・R」が津堅にんじんの魅力をおしゃれに引き出した特別なロールケーキ。津堅にんじんで作ったゼリーやジャム、パウダーを施し、生地と生クリームにはフランス産クリームチーズを練り込んだ贅沢な一品です。しっとりふんわりとした生地の上には、オレンジ色の野原をかけるウサギのデザイン♪　ウサギをあしらったオレンジの風呂敷をおかけします。長さ約12センチ。
                </p>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-lg mr-3 mt-0.5"></i>
                    <span className="text-sm text-gray-700">津堅島産にんじんを食べやすくアレンジ</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-lg mr-3 mt-0.5"></i>
                    <span className="text-sm text-gray-700">大人向けの上品な味わい</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-lg mr-3 mt-0.5"></i>
                    <span className="text-sm text-gray-700">特別な日のデザート、贈り物に最適</span>
                  </li>
                </ul>
                <p className="text-sm text-gray-500 italic">
                  製造者:レストランBBR(沖縄県うるま市)
                </p>
              </div>
              <div className="order-1 md:order-2">
                <div className="w-full h-96 rounded-2xl overflow-hidden shadow-lg">
                  <img 
                    src="https://static.readdy.ai/image/01cf1105d91d36948be7a446b8f667b1/72c38ef7c4ba9d77586dd7d2d34acd87.jpeg" 
                    alt="津堅にんじんロールケーキ" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
            </div>
          </div>

          {/* 商品② ロールパン */}
          <div>
            <div className="grid md:grid-cols-2 gap-12 items-center">
              <div>
                <div className="w-full h-96 rounded-2xl overflow-hidden shadow-lg">
                  <img 
                    src="https://static.readdy.ai/image/01cf1105d91d36948be7a446b8f667b1/a76da723fa778b75bcfb37c3d9727509.jpeg" 
                    alt="復刻・津堅にんじんロール" 
                    className="w-full h-full object-cover object-top"
                  />
                </div>
              </div>
              <div>
                <div className="inline-block px-4 py-1.5 bg-orange-100 text-orange-600 text-xs font-medium rounded-full mb-4">
                  復刻・イベント限定
                </div>
                <p className="text-sm text-gray-500 font-medium mb-2">Boulangerie i+plus</p>
                <h3 className="text-3xl font-bold text-gray-900 mb-4">
                  復刻・津堅にんじんロール
                </h3>
                <p className="text-2xl font-bold text-orange-500 mb-6">
                  1本 4,000円<span className="text-base font-normal text-gray-600">（税込）</span>
                </p>
                <p className="text-base text-gray-600 leading-relaxed mb-6">
                  2014年、沖縄県うるま市の商品開発事業で誕生し、現在は通常販売されていない幻の商品。知る人ぞ知る同市の人気ベーカリー「Boulangerie i+plus（ブーランジェリー・アイプラス）」が、本イベントのために特別復刻しました。津堅にんじんを贅沢に使用し、自然の甘味をさらに引き出すよう工夫。糸満の平飼い有精卵に県産和三盆など素材にこだわり、ずしりと重く迫力のあるサイズ感が特徴です。長さ約16センチ。
                </p>
                <ul className="space-y-3 mb-8">
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-lg mr-3 mt-0.5"></i>
                    <span className="text-sm text-gray-700">2014年誕生の復刻商品</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-lg mr-3 mt-0.5"></i>
                    <span className="text-sm text-gray-700">大量生産ができない特別な企画商品</span>
                  </li>
                  <li className="flex items-start">
                    <i className="ri-checkbox-circle-fill text-orange-500 text-lg mr-3 mt-0.5"></i>
                    <span className="text-sm text-gray-700">津堅にんじんの可能性を「作品」として表現</span>
                  </li>
                </ul>
                <p className="text-sm text-gray-500 italic">
                  製造者:アイプラス(沖縄県うるま市)
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 作り手紹介セクション */}
      <section className="py-20 px-6 bg-gradient-to-b from-white to-gray-50">
        <div className="container mx-auto max-w-6xl">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-16">
            作り手の想い
          </h2>

          <div className="space-y-20">
            {/* レストランBBR */}
            <div className="grid md:grid-cols-2 gap-12 items-start">
              <div className="w-full h-80 rounded-2xl overflow-hidden shadow-md">
                <img 
                  src="https://static.readdy.ai/image/01cf1105d91d36948be7a446b8f667b1/7a5efa76200e658c48217140d67f8678.jpeg" 
                  alt="レストランBBR 製作風景" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="space-y-5">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">Restaurant B・B・R</h3>
                  <p className="text-sm text-gray-500 mb-6">― 沖縄の自然の恵みを「美しく」「おいしく」 ―</p>
                </div>
                <p className="text-sm text-gray-700 leading-relaxed">
                  うるま市大田の住宅街の一角、緑に囲まれた隠れ家のようなフレンチレストラン。<br />
                  新鮮で良質な県産食材を厳選し、沖縄ならではのフレンチを信条として22年。<br />
                  色とりどりの新鮮野菜に、近くの南原漁港から仕入れた鮮魚や県産豚を合わせ、<br />
                  地のものにこだわったコース料理を提供しています。
                </p>
                <p className="text-sm text-gray-700 leading-relaxed">
                  オーナーシェフは端慶覧篤さん。<br />
                  沖縄県内のホテルや本場フランスでフレンチの腕を磨いて39歳で開業。<br />
                  ほぼ毎朝、漁港に通い、休みの日も県内各地へ食材探しに出かけます。<br />
                  「沖縄に生まれ育った者として、沖縄の良いものを提供したい気持ちが強い。<br />
                  必ず自分で見て、手にとって選んでいます」（妻でスタッフの由美子さん）。
                </p>
                <p className="text-sm text-gray-700 leading-relaxed">
                  スイーツも地場の特産品を取り入れ、一つひとつ手作りです。<br />
                  「津堅にんじんロールケーキ」は、<br />
                  ニンジンをゼリーやジャム、パウダーに食べやすくアレンジし、<br />
                  フランス産チーズを合わせて高級感ある風味に仕上げています。
                </p>
                <p className="text-sm text-gray-700 leading-relaxed">
                  店外では販売していないところ、本イベントのために限定出品。<br />
                  にんじんとチーズを上手に調和させた上品な味わいをぜひどうぞ！
                </p>
              </div>
            </div>

            {/* アイプラス */}
            <div className="grid md:grid-cols-2 gap-12 items-start">
              <div className="order-2 md:order-1 space-y-5">
                <div>
                  <h3 className="text-2xl font-bold text-gray-900 mb-2">Boulangerie i+plus</h3>
                  <p className="text-sm text-gray-500 mb-6">― 素材と向き合い、日常のパンをつくる ―</p>
                </div>
                <p className="text-sm text-gray-700 leading-relaxed">
                  沖縄県うるま市にあるベーカリー「アイプラス」は、<br />
                  派手さよりも、素材と向き合う姿勢を大切にするパン屋です。
                </p>
                <p className="text-sm text-gray-700 leading-relaxed">
                  一度にたくさん作ることはできませんが、<br />
                  生地の状態や焼き上がりを確かめながら、<br />
                  一つひとつ丁寧にパンを焼き上げています。
                </p>
                <p className="text-sm text-gray-700 leading-relaxed">
                  うるま市栄野比の小道に入ったところにある一軒家。<br />
                  店名も書かれていない、ただ「Open」と書かれた看板だけを頼りにドアを開けると、<br />
                  そこには魅力的なデニッシュ類やクロワッサン！　一気にかぐわしい香りに包まれます。
                </p>
                <p className="text-sm text-gray-700 leading-relaxed">
                  「ブーランジェリー・アイプラス」は、素材にこだわるパン職人・近藤逸志さんが<br />
                  粉から成形し、何と全て自然発酵で丁寧に焼き上げています。
                </p>
                <p className="text-sm text-gray-700 leading-relaxed">
                  フランス人が作るクロワッサンに感動し、パティシエからパン屋に転向。<br />
                  「津堅にんじんロール」は、そんな近藤さんが工夫を凝らして編み出した、<br />
                  パン生地とお菓子の中間点のような"ロールケーキ"です。<br />
                  「津堅にんじんは煮詰めて、その甘みがさらに際立つようにした。<br />
                  砂糖の使用は通常の半分以下にでき、自然の甘みに近い商品となった」<br />
                  という自信作。
                </p>
                <p className="text-sm text-gray-700 leading-relaxed">
                  今回はうるマルシェの本イベント限定で特別製作。<br />
                  沖縄や九州の安心・安全な素材を用い、自然発酵を経て焼き上げます。<br />
                  職人こだわりの"作品"をお楽しみください。
                </p>
              </div>
              <div className="order-1 md:order-2 w-full h-80 rounded-2xl overflow-hidden shadow-md">
                <img 
                  src="https://static.readdy.ai/image/01cf1105d91d36948be7a446b8f667b1/08702c2a0bfb67bfac6f494429f68548.jpeg" 
                  alt="アイプラス 製作風景" 
                  className="w-full h-full object-cover object-top"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* 導入セクション */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            なぜ、津堅にんじんは特別なのか
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-8">
            キャロットアイランドと呼ばれる沖縄県うるま市の小さな離島・津堅島。島尻マージという赤土の水はけの良い畑が広がり、沖縄の陽光とミネラル豊富な潮風を受けた土壌で津堅にんじんがすくすくと育ちます。収穫の最盛期は２〜４月。限られた土地と生産量の中で丁寧に栽培され、甘みと栄養価の高いニンジンです。
          </p>
          <div className="grid md:grid-cols-3 gap-8 mt-12">
            <div className="bg-white p-8 rounded-xl shadow-sm">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-plant-line text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">限られた生産地</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                津堅島の豊かな土壌と気候が育む、特別なにんじんです。
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">自然な甘み</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                えぐみが少なく、素材本来の甘みを楽しめる味わいです。
              </p>
            </div>
            <div className="bg-white p-8 rounded-xl shadow-sm">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-star-line text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-lg font-bold text-gray-900 mb-3">加工適性の高さ</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                お菓子やパンなど、様々な加工に適した特性を持ちます。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* 比較・選び方セクション */}
      <section className="py-20 px-6 bg-gray-50">
        <div className="container mx-auto max-w-5xl">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
            どちらを選ぶ?
          </h2>
          <div className="grid md:grid-cols-2 gap-8">
            <div className="bg-white p-8 rounded-2xl shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-4">津堅にんじんロールケーキ</h3>
              <p className="text-3xl font-bold text-orange-500 mb-6">2,100円</p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 text-xl mr-3 mt-0.5"></i>
                  <span className="text-sm text-gray-700">上品で軽やかな味わい</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 text-xl mr-3 mt-0.5"></i>
                  <span className="text-sm text-gray-700">大人向けのデザート</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 text-xl mr-3 mt-0.5"></i>
                  <span className="text-sm text-gray-700">かわいいウサギがチャームポイント</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 text-xl mr-3 mt-0.5"></i>
                  <span className="text-sm text-gray-700">風呂敷付きで贈り物にも最適</span>
                </li>
              </ul>
            </div>
            <div className="bg-white p-8 rounded-2xl shadow-sm">
              <h3 className="text-xl font-bold text-gray-900 mb-4">復刻・津堅にんじんロール</h3>
              <p className="text-3xl font-bold text-orange-500 mb-6">4,000円</p>
              <ul className="space-y-3">
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 text-xl mr-3 mt-0.5"></i>
                  <span className="text-sm text-gray-700">迫力のあるサイズ感の</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 text-xl mr-3 mt-0.5"></i>
                  <span className="text-sm text-gray-700">希少性の高い復刻商品</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 text-xl mr-3 mt-0.5"></i>
                  <span className="text-sm text-gray-700">人気ベーカリーが工夫を凝らした逸品</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-orange-500 text-xl mr-3 mt-0.5"></i>
                  <span className="text-sm text-gray-700">津堅にんじんを「作品」として味わう</span>
                </li>
              </ul>
            </div>
          </div>
          <p className="text-center text-base text-gray-600 mt-12 leading-relaxed">
            用途やお好みに応じて、お選びいただけます。<br />
            どちらも津堅にんじんの魅力を存分に味わえる特別な商品です。
          </p>
        </div>
      </section>

      {/* ご注文方法セクション */}
      <section className="py-20 px-6">
        <div className="container mx-auto max-w-4xl">
          <h2 className="text-3xl font-bold text-gray-900 text-center mb-12">
            ご注文方法
          </h2>
          <div className="bg-white border-2 border-gray-200 rounded-2xl p-10">
            <div className="space-y-8">
              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center font-bold text-lg mr-6 flex-shrink-0">
                  1
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">ご予約</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    うるマルシェ通販サイトよりお申込みください。<br />
                    お支払いはクレジットカード決済となります。
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center font-bold text-lg mr-6 flex-shrink-0">
                  2
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">お受け取り方法の選択</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    <strong>店頭引き取り:</strong> 2026年3月7日 イベント当日、うるマルシェ・サービスカウンターにてお受け取りください。<br />
                    <strong>宅配発送:</strong> 送料着払いでの発送(冷凍)も可能です。
                  </p>
                </div>
              </div>
              <div className="flex items-start">
                <div className="w-12 h-12 bg-orange-500 text-white rounded-full flex items-center justify-center font-bold text-lg mr-6 flex-shrink-0">
                  3
                </div>
                <div>
                  <h3 className="text-lg font-bold text-gray-900 mb-2">数量限定</h3>
                  <p className="text-sm text-gray-600 leading-relaxed">
                    両商品とも数量限定のため、事前予約をおすすめいたします。<br />
                    売り切れの際はご容赦ください。
                  </p>
                </div>
              </div>
            </div>
            <div className="mt-10 text-center">
              <a 
                href="https://urumarche.myshopify.com/collections/%E9%99%90%E5%AE%9A%E8%B2%A9%E5%A3%B2-%E6%B4%A5%E5%A0%85%E3%81%AB%E3%82%93%E3%81%98%E3%82%93%E3%83%AD%E3%83%BC%E3%83%AB-%E5%BA%97%E9%A0%AD%E5%8F%97%E5%8F%96%E3%81%AE%E3%81%BF"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-10 py-4 bg-orange-500 text-white text-base font-bold rounded-full hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                今すぐ予約する
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTAセクション */}
      <section className="py-20 px-6 bg-gradient-to-br from-orange-50 to-orange-100">
        <div className="container mx-auto max-w-4xl text-center">
          <h2 className="text-3xl font-bold text-gray-900 mb-6">
            イベント当日、会場でお待ちしております
          </h2>
          <p className="text-lg text-gray-600 leading-relaxed mb-8">
            津堅にんじんの可能性を、特別な2つの商品でお楽しみください。<br />
            数量限定のため、お早めのご予約をおすすめいたします。
          </p>
          <div className="inline-block bg-white px-8 py-4 rounded-xl shadow-sm">
            <p className="text-sm text-gray-500 mb-1">開催日</p>
            <p className="text-2xl font-bold text-orange-500">2026年3月7日</p>
          </div>
        </div>
      </section>

      {/* フッター */}
      <footer className="bg-gray-900 text-white py-16 px-6">
        <div className="container mx-auto max-w-6xl">
          <div className="grid md:grid-cols-3 gap-12 mb-12">
            <div>
              <img 
                src="https://static.readdy.ai/image/01cf1105d91d36948be7a446b8f667b1/8f1db646094399b0c1803ff796086d6b.png" 
                alt="うるマルシェ" 
                className="h-12 w-auto mb-4 brightness-0 invert"
              />
              <p className="text-sm text-gray-400 leading-relaxed">
                地域食材の魅力を伝え、<br />
                生産振興と地域活性化に<br />
                取り組んでいます。
              </p>
            </div>
            <div>
              <h4 className="text-base font-bold mb-4">お問い合わせ</h4>
              <p className="text-sm text-gray-400 leading-relaxed">
                商品に関するご質問は、<br />
                うるマルシェ通販サイトより<br />
                お問い合わせください。
              </p>
            </div>
            <div>
              <h4 className="text-base font-bold mb-4">イベント情報</h4>
              <p className="text-sm text-gray-400 leading-relaxed">
                開催日: 2026年3月7日<br />
                場所: 沖縄県うるま市<br />
                予約販売・数量限定
              </p>
            </div>
          </div>
          <div className="border-t border-gray-800 pt-8 flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm text-gray-500 mb-4 md:mb-0">
              © 2026 うるマルシェ. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo" 
              target="_blank" 
              rel="noopener noreferrer"
              className="text-sm text-gray-500 hover:text-gray-300 transition-colors cursor-pointer"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </footer>

      {/* 予約モーダル */}
      {showOrderModal && (
        <div className="fixed inset-0 bg-black/50 z-50 flex items-center justify-center p-4" onClick={() => setShowOrderModal(false)}>
          <div className="bg-white rounded-2xl max-w-md w-full p-8" onClick={(e) => e.stopPropagation()}>
            <div className="text-center">
              <div className="w-16 h-16 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-shopping-cart-line text-3xl text-orange-500"></i>
              </div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">ご予約について</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-6">
                うるマルシェ通販サイトにて、<br />
                商品のご予約を承っております。<br />
                下記ボタンより通販サイトへお進みください。
              </p>
              <a 
                href="https://urumarche.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="inline-block px-8 py-3 bg-orange-500 text-white text-base font-medium rounded-full hover:bg-orange-600 transition-colors whitespace-nowrap cursor-pointer mb-4"
              >
                通販サイトへ
              </a>
              <button 
                onClick={() => setShowOrderModal(false)}
                className="block w-full py-2.5 text-sm text-gray-500 hover:text-gray-700 transition-colors cursor-pointer"
              >
                閉じる
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}